// https://observablehq.com/d/ff0eb6799ff5477a@508
export default function define(runtime, observer) {
  const main = runtime.module();
  main.variable(observer()).define(["md"], function(md){return(
md`# Horizontal bar chart`
)});
  main.variable(observer("chart")).define("chart", ["d3","DOM","viewof settings","settings","rawData","chartData","barPadding","labelFn","barHeight","stroke","fmtAreaFn","blackOrWhite","hasUnclassified"], function(d3,DOM,$0,settings,rawData,chartData,barPadding,labelFn,barHeight,stroke,fmtAreaFn,blackOrWhite,hasUnclassified)
{
  let c = d3.select(DOM.element('div'))
    .attr('class', 'frag-horizontal-bar-chart');
  let updateSettings = (changedSettings) => {
    $0.value = Object.assign({}, settings, changedSettings);
  }
  
  let total = rawData.response.area;
  
  let toggleSort = (k, defaultOrder) => {
    let order = defaultOrder;
    let sort = k;
    if (settings.sort == k) {
      sort = settings.order == 'DESC' ? null : k;
      order = settings.order == 'ASC' ? 'DESC' : 'ASC';
    }
    
    let set = { sort, order };
    updateSettings(set);
  };
  
  let sortbtns = [
    {name:'Label', k: 'name', cls: 'sort-by-label-btn sort-btn'},
    {name:'Value', k: 'value', cls: 'sort-by-value-btn sort-btn'}
  ];
  
  c.selectAll('button.sort-button').data(sortbtns)
    .enter()
    .append('button')
    .attr('class', d => d.cls + (settings.sort == d.k ? ' active' : ''))
    .text(d => {
      let up = '▲';
      let down = '▼';
      let carat = settings.sort == d.k ? (settings.order == 'ASC' ? up : down) : up;
      return d.name + ' ' + carat;
    })
    .on('click', d => toggleSort(d.k, 'ASC'));
  
  let x = d3.scaleLinear().range([0, 100]).domain([0, d3.max(chartData, d=>d.value)]);
  let sortFn = settings.order == 'ASC' ? d3.ascending : d3.descending;
  let sortedChartData = [...chartData].sort((a,b) => sortFn(a[settings.sort || 'Class'], b[settings.sort || 'Class']));

  let divEnter = c.selectAll('div.horizontal-bar-chart-row')
    .data(sortedChartData)
    .enter()
    .append('div')
    .attr('class', 'horizontal-bar-chart-row')
    .style('width', '100%')
    .style('margin-bottom', `${barPadding}px`)
    .style('position', 'relative')
    .style('display', 'flex')
    .style('flex-direction', 'row')
    .style('align-items', 'center');

  divEnter.append('span')
    .style('text-align', 'right')
    .style('vertical-align', 'middle')
    // .style('min-height', `${barHeight}px`)
    .style('display', 'inline-block')
    .style('width', 'calc(20% - 3px)')
    .style('font-size', 'small')
    .style('padding-right', '3px')
    .style('word-break', 'break-word')
    .text(labelFn);

  let barOuters = divEnter
    .append('div')
    .style('position', 'relative')
    .style('display', 'inline-block')
    .style('height', `${barHeight}px`)
    .style('width', '80%')
    .style('padding-left', '1px')
    .style('vertical-align', 'middle');
  // use svg inside each bar so that the colours are printed
  barOuters.append('svg')
    .attr('width', d => `${x(d.value)}%`)
    .attr('height', `${barHeight}px`)    
    .style('height', `${barHeight}px`)
    .append('rect')
    .attr('x', 0)
    .attr('y', 1)
    .attr('width', '100%')
    .attr('height', barHeight-2)
    .attr('stroke', stroke)
    .style('stroke-opacity', 0.6)
    .attr('fill', d => d.color);

  let fmt = settings.fmt;
  let fmtFn;
  if(fmt == 'ha') fmtFn = d => fmtAreaFn(d.value)
  else fmtFn = d => (100 * d.value / total).toFixed(1) + '%';
  
  // draw the labels
  barOuters.append('div')
    .style('position', 'absolute')
    .style('top', '0')
    .style('left', d => {
      let pct = x(d.value);
      if (pct >= 70) {
        return null;
      }
      return `calc(${pct}% + 3px`
    })
    .style('right', d => {
      let pct = x(d.value);
      if (pct >= 70) {
        return `calc(${100 - pct}% + 3px`
      }
      return null;
    })
    .style('height', `${barHeight}px`)
    .style('vertical-align', 'middle')
    .style('line-height', `${barHeight}px`)
    .style('font-size', 'small')
    .style('color', d => {
      let pct = x(d.value);
      return pct >= 70 ? blackOrWhite(d.color) : '#000';
    })
    .text(fmtFn);  
  
  const lowerControls = c.append('div')
    .attr('class', 'lower-controls')
    .style("padding-left", "20%");
  
  lowerControls.selectAll('button.fmt-button')
    .data(['ha', ' % '])
    .enter()
    .append('button')
    .attr('class', d => {
        return 'fmt-button' + (settings.fmt == d ? ' active' : ''); 
    })
    .text(d => d)
    .on('click', d => updateSettings({fmt: d}));
  
  if (hasUnclassified) {
    lowerControls.append('span').attr('class', 'spacer');
    
    lowerControls.append('label')
      .attr('class', 'no-print')
      .style('float', 'right')
      .text('Show unclassified/other?')
      .append('input')
      .attr('type', 'checkbox')
      .property('checked', settings.includeOther)
      .on('change', function() {
        updateSettings({includeOther: !settings.includeOther})
        this.checked = settings.includeOther;
      });  
  }
  
  return c.node();
}
);
  main.variable(observer("gis")).define("gis", ["require"], function(require){return(
require("@manaakiwhenua/frag-helper@0.0.7/dist/umd/gis-portals-transformers/index.js")
)});
  main.variable(observer("totalArea")).define("totalArea", ["rawData"], function(rawData){return(
rawData.response.area
)});
  main.variable(observer("fmtAreaFn")).define("fmtAreaFn", function(){return(
(m2) => {
  let hectares = m2/10000;
  
  if (hectares < 1) {
    return `< 1ha`;
  }
  return `${Math.round(hectares).toLocaleString()}ha`;
}
)});
  main.variable(observer("includeUnclassified")).define("includeUnclassified", function(){return(
true
)});
  main.variable(observer("stroke")).define("stroke", function(){return(
d => d.abbr == 'unc' ? 'black' : null
)});
  main.variable(observer("hasUnclassified")).define("hasUnclassified", ["chartDataWithUnc"], function(chartDataWithUnc){return(
chartDataWithUnc.some(d => d.abbr == 'unc')
)});
  main.variable(observer("labelFn")).define("labelFn", function(){return(
d => d.name
)});
  main.variable(observer("chartDataWithUnc")).define("chartDataWithUnc", ["gis","rawData"], function(gis,rawData){return(
gis.AreaQuery.responseToGroupableTabularData(rawData, true)
)});
  main.variable(observer("chartData")).define("chartData", ["settings","chartDataWithUnc"], function(settings,chartDataWithUnc){return(
settings.includeOther ? chartDataWithUnc : chartDataWithUnc.filter(c => c.abbr != 'unc')
)});
  main.variable(observer("colors")).define("colors", ["chartData"], function(chartData){return(
chartData.map(c => c.color)
)});
  main.variable(observer("d3")).define("d3", ["require"], function(require){return(
require('d3@5')
)});
  main.variable(observer("barHeight")).define("barHeight", function(){return(
50
)});
  main.variable(observer("barPadding")).define("barPadding", function(){return(
3
)});
  main.variable(observer("padding")).define("padding", function()
{
  return {
    top: 2,
    bottom: 2,
    left: 80,
    right: 50
  }
}
);
  main.variable(observer("height")).define("height", ["padding","chartData","barHeight","barPadding"], function(padding,chartData,barHeight,barPadding){return(
padding.top + chartData.length * (barHeight + barPadding) + padding.bottom
)});
  main.variable(observer("rawData")).define("rawData", function()
{
  return {"response":{"area":1.2696955142131252E10,"layers":[{"name":"wetlands_historic","raster":false,"rows":[{"columns":[{"name":"Class","value":"0"},{"name":"Class Description","value":"Bog (h)"},{"name":"Class Color","value":"#96825f"},{"name":"Class Area","value":1193385.2268798929},{"name":"Class Abbreviation","value":"hBog"},{"name":"Class Flags","value":3},{"name":"Class Flags Hash","value":{"SHOW_LONG_NAME_IN_CONTENTS":false,"HIDE_FROM_CONTENTS_PAGE":false,"VISUALISATION":true,"QUERY_ABLE":true}}],"number":1},{"columns":[{"name":"Class","value":"1"},{"name":"Class Description","value":"Fen (h)"},{"name":"Class Color","value":"#b4d264"},{"name":"Class Area","value":2.2564951721090887E7},{"name":"Class Abbreviation","value":"hFen"},{"name":"Class Flags","value":3},{"name":"Class Flags Hash","value":{"SHOW_LONG_NAME_IN_CONTENTS":false,"HIDE_FROM_CONTENTS_PAGE":false,"VISUALISATION":true,"QUERY_ABLE":true}}],"number":2},{"columns":[{"name":"Class","value":"4"},{"name":"Class Description","value":"Marsh (h)"},{"name":"Class Color","value":"#b4ffff"},{"name":"Class Area","value":1.063706836886548E8},{"name":"Class Abbreviation","value":"hMsh"},{"name":"Class Flags","value":3},{"name":"Class Flags Hash","value":{"SHOW_LONG_NAME_IN_CONTENTS":false,"HIDE_FROM_CONTENTS_PAGE":false,"VISUALISATION":true,"QUERY_ABLE":true}}],"number":3},{"columns":[{"name":"Class","value":"6"},{"name":"Class Description","value":"Seepage (h)"},{"name":"Class Color","value":"#96ff96"},{"name":"Class Area","value":502906.08583556855},{"name":"Class Abbreviation","value":"hSee"},{"name":"Class Flags","value":3},{"name":"Class Flags Hash","value":{"SHOW_LONG_NAME_IN_CONTENTS":false,"HIDE_FROM_CONTENTS_PAGE":false,"VISUALISATION":true,"QUERY_ABLE":true}}],"number":4},{"columns":[{"name":"Class","value":"7"},{"name":"Class Description","value":"Swamp (h)"},{"name":"Class Color","value":"#009600"},{"name":"Class Area","value":3.6707830513015294E8},{"name":"Class Abbreviation","value":"hSwp"},{"name":"Class Flags","value":3},{"name":"Class Flags Hash","value":{"SHOW_LONG_NAME_IN_CONTENTS":false,"HIDE_FROM_CONTENTS_PAGE":false,"VISUALISATION":true,"QUERY_ABLE":true}}],"number":5}]},{"name":"wetlands_current","raster":false,"rows":[{"columns":[{"name":"Class","value":"0"},{"name":"Class Description","value":"Bog (c)"},{"name":"Class Color","value":"#6e5a4b"},{"name":"Class Area","value":836520.5371468561},{"name":"Class Abbreviation","value":"cBog"},{"name":"Class Flags","value":3},{"name":"Class Flags Hash","value":{"SHOW_LONG_NAME_IN_CONTENTS":false,"HIDE_FROM_CONTENTS_PAGE":false,"VISUALISATION":true,"QUERY_ABLE":true}}],"number":1},{"columns":[{"name":"Class","value":"1"},{"name":"Class Description","value":"Fen (c)"},{"name":"Class Color","value":"#82a03c"},{"name":"Class Area","value":763947.1750264161},{"name":"Class Abbreviation","value":"cFen"},{"name":"Class Flags","value":3},{"name":"Class Flags Hash","value":{"SHOW_LONG_NAME_IN_CONTENTS":false,"HIDE_FROM_CONTENTS_PAGE":false,"VISUALISATION":true,"QUERY_ABLE":true}}],"number":2},{"columns":[{"name":"Class","value":"4"},{"name":"Class Description","value":"Marsh (c)"},{"name":"Class Color","value":"#82ffff"},{"name":"Class Area","value":1.0734850523575826E7},{"name":"Class Abbreviation","value":"cMsh"},{"name":"Class Flags","value":3},{"name":"Class Flags Hash","value":{"SHOW_LONG_NAME_IN_CONTENTS":false,"HIDE_FROM_CONTENTS_PAGE":false,"VISUALISATION":true,"QUERY_ABLE":true}}],"number":3},{"columns":[{"name":"Class","value":"6"},{"name":"Class Description","value":"Seepage (c)"},{"name":"Class Color","value":"#1eff1e"},{"name":"Class Area","value":446029.3938245664},{"name":"Class Abbreviation","value":"cSee"},{"name":"Class Flags","value":3},{"name":"Class Flags Hash","value":{"SHOW_LONG_NAME_IN_CONTENTS":false,"HIDE_FROM_CONTENTS_PAGE":false,"VISUALISATION":true,"QUERY_ABLE":true}}],"number":4},{"columns":[{"name":"Class","value":"7"},{"name":"Class Description","value":"Swamp (c)"},{"name":"Class Color","value":"#005000"},{"name":"Class Area","value":1.7461434136238296E7},{"name":"Class Abbreviation","value":"cSwp"},{"name":"Class Flags","value":3},{"name":"Class Flags Hash","value":{"SHOW_LONG_NAME_IN_CONTENTS":false,"HIDE_FROM_CONTENTS_PAGE":false,"VISUALISATION":true,"QUERY_ABLE":true}}],"number":5}]}],"pointHeight":0}}
}
);
  main.variable(observer("color")).define("color", function(){return(
d => d.color
)});
  main.variable(observer("viewof settings")).define("viewof settings", ["View"], function(View){return(
new View({ fmt: 'ha', 'sort': 'Class', 'order': 'ASC', 'includeOther': true}, 'settings')
)});
  main.variable(observer("settings")).define("settings", ["Generators", "viewof settings"], (G, _) => G.input(_));
  main.variable(observer("View")).define("View", function(){return(
class View {
  constructor(value, id) {
    Object.defineProperties(this, {
      _list: {value: [], writable: true},
      _value: {value, writable: true}
    });
  }
  get value() {
    return this._value;
  }
  set value(value) {
    this._value = value;
    this.dispatchEvent({type: "input", value});
  }
  addEventListener(type, listener) {
    if (type != "input" || this._list.includes(listener)) return;
    this._list = [listener].concat(this._list);
  }
  removeEventListener(type, listener) {
    if (type != "input") return;
    this._list = this._list.filter(l => l !== listener);
  }
  dispatchEvent(event) {
    const p = Promise.resolve(event);
    this._list.forEach(l => p.then(l));
  }
}
)});
  main.variable(observer("blackOrWhite")).define("blackOrWhite", ["d3"], function(d3){return(
(c) => {
  let rgb = d3.rgb(c);
  let [r,g,b] = [rgb.r, rgb.g, rgb.b]
    .map(c => c / 255.0)
    .map(c => c <= 0.03928 ? c/12.92 : Math.pow(((c+0.055)/1.055), 2.4));
  let l = 0.2126 * r + 0.7152 * g + 0.0722 * b;
  return l > 0.179 ? '#000000' : '#ffffff';
}
)});
  return main;
}
